module.exports = __webpack_public_path__ + "img/DSC_0180 teatro 1_thumb.0a5799ae.jpg";